export abstract class PersistenceProvider {
    public abstract set(key: string, value: any, json?: boolean): void;

    public abstract get(key: string, json?: boolean): any;

    public abstract remove(key: string): void;

    public abstract removeAll(): void;
}
